import { Controller } from 'stimulus';
export default class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.ondisconnects = [];
    }
    async connect() {
        const target = this.editableTarget;
        const height = this.data.get('height');
        const { tinymce } = await import('./tinymce');
        tinymce
            .init({
            target,
            height,
            language: 'ja',
            theme: 'silver',
            skin: 'oxide',
            base_url: '/tinymce',
            branding: false,
            forced_root_block: false,
            cache_suffix: `?v=${tinymce.majorVersion}.${tinymce.minorVersion}`,
            plugins: ['lists advlist link save paste'],
            toolbar: 'undo redo | bullist numlist | link',
            init_instance_callback: editor => {
                editor.on('Change', () => {
                    target.value = editor.getContent();
                });
            },
        })
            .then(editors => this.ondisconnects.push(() => editors.forEach(e => e.remove())));
    }
    disconnect() {
        this.ondisconnects.forEach(callback => callback());
        this.ondisconnects.length = 0;
    }
}
default_1.targets = ['editable'];
